import Class from './c-board-right';
import './c-board-right@';

export default Class;